import React, { Component } from 'react';

class ComboInstancia extends Component {

    render() {
        const { selectCombo, options, descripcion, inhabilitarComboFiltros, filtro } = this.props

        return (
            <div>
                <select disabled={inhabilitarComboFiltros} value={-1} name="instancias" className="form-control default-select confirmadorAjusteCargoSeccionSuperiorSelect" onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo(filtro,value,index)
                }}>
                    <option key={-1} value={-1}>{descripcion}</option>
                    {options && options.length > 0 && options.map((item, index) => { return <option key={index} value={item.Id}>{item.Descripcion}</option> })}
                </select>
            </div>
        );
    }
}

export default ComboInstancia;